<template>
  <!-- Show toast with text: Thank you! We received your suggestion 😄 -->

  <div class="page-container" style="min-height: 700px;">
    <div class="page-title-container">
      <h1 class="title-text">Thank you! We received your suggestion 😄</h1>
      <h1 class="title-text">Do you want to suggest another site?</h1>
      <h2 class="subtitle-text">
        WE LOVE TO KNOW NEW SITES TO ADD ON JOBBOARDY
      </h2>
    </div>

    <div class="center-items">
      <div class="buttons-container">
        <!-- Goes to suggest site page -->
        <button @click="$router.push({ path: '/suggest-site' })" class="primary-button" type="button">
          Yes, suggest site!
        </button>

        <!-- Goes to landing page -->
        <button @click="$router.push({ path: '/' })" class="secondary-button" type="button">
          Maybe later
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  created() {
    window.scrollTo(0, 0);
  },
};
</script>

<style></style>
